import api from './api';

const paymentMilestoneService = {
    addMilestone: async (data) => {
        return await api.post('/payment-milestones', data);
    },

    getMilestonesByOrder: async (orderId) => {
        return await api.get(`/payment-milestones/order/${orderId}`);
    },

    getOrderPaymentSummary: async (orderId) => {
        return await api.get(`/payment-milestones/summary/${orderId}`);
    },

    deleteMilestone: async (id) => {
        return await api.delete(`/payment-milestones/${id}`);
    }
};

export default paymentMilestoneService;
